import { WindowLocationService } from '~src/commonInfra/services/WindowLocationService';

import {showRouterError} from '../app/actions/spaces/RouterErrorActions';
import {getAppStore} from '../app/AppStore';
import {ServerUrls} from '../app/ServerUrls';
import {LoginUrlsWrapper} from '../app/spaces/Login/LoginUrls';
import {AuthLevel, getSessionManagementServiceInstance} from '../sessionManagement/SessionManagementService';
import {SolrErrorCode} from '../ts/helpers/ErrorCodes';

export function maybeHandleSearchServerDown(errorCode: number) {
    // extract path portion from fragment and remove leading '#' to match expected format that previous angular code returned
    const path = WindowLocationService.getFragmentWithoutQuery().substring(1);

    if (errorCode && errorCode === SolrErrorCode.SolrCommunicationError || errorCode === SolrErrorCode.SolrDisabled) {
        if (!getSessionManagementServiceInstance().isUserAuthorized(AuthLevel.ServerAdmin)) {
            LoginUrlsWrapper.navigateToSignInErrorCode('' + errorCode);
        } else if (path !== ServerUrls.getInstance().statusPath()) {
            getAppStore().dispatch(showRouterError('search-server-down'));
        }
        return true;
    } else {
        return false;
    }
}